import { useMutation } from '@tanstack/react-query';
import { IWhiteLabelForm, WhitelabelOrganizationShow } from 'api/types';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

import { queryClient } from '../../configs/queryClient';

async function updateWhitelabelOrganization(axios: AxiosInstance, wloId: number, wloData: IWhiteLabelForm): Promise<WhitelabelOrganizationShow> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/whitelabel-organizations/${wloId}`, { ...wloData, auth0_connection_type: 'auth0' });
  return data;
}

export default function useUpdateWhitelabelOrganizationMutation() {
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ wloData, wloId }: { wloData: IWhiteLabelForm; wloId: number }) => updateWhitelabelOrganization(axios, wloId, wloData),
    onSuccess: (data: WhitelabelOrganizationShow) => {
      queryClient.invalidateQueries({ queryKey: ['Whitelabel Organization', data?.id] });
    },
  });
}
